module.exports = __webpack_public_path__ + "static/img/logo.ee83f4d8.png";